import type { ComponentType, ReactNode } from 'react';
import { ArrowRight } from 'lucide-react';

const SIZES = {
  sm: { wrap: 'h-7 w-7', icon: 'h-3.5 w-3.5' },
  md: { wrap: 'h-8 w-8', icon: 'h-4 w-4' },
};

/** A section or widget icon in a charcoal circle, matching the avatars */
export function IconBadge({
  icon: Icon,
  size = 'md',
}: Readonly<{
  icon: ComponentType<{ className?: string }>;
  size?: keyof typeof SIZES;
}>) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-full bg-modern-charcoal text-white ${SIZES[size].wrap}`}
    >
      <Icon className={SIZES[size].icon} />
    </span>
  );
}

/** A charcoal pill button for "Open …" / "View all" style links */
export function ActionBadge({
  onClick,
  children,
}: Readonly<{ onClick: () => void; children: ReactNode }>) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-1 rounded-full bg-modern-charcoal px-3 py-1 text-xs font-medium text-white shadow-sm transition-colors hover:bg-modern-light-charcoal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-modern-charcoal focus-visible:ring-offset-2"
    >
      {children}
      <ArrowRight className="h-3 w-3" />
    </button>
  );
}
